angular.module('agreements')
    .component('workflowLinksTable', {
        bindings: {
            workflowId: '<'
        },
        templateUrl: 'app/workflow/links/links-table.html',
        controller: function ($scope, modals, Workflow, WorkflowService) {
            this.WorkflowService = WorkflowService

            this.$onChanges = () => {
                this.load()
            }

            this.load = () => Workflow.allGranted({linkedWorkflowId: this.workflowId}).$promise.then(result => {
                this.page = result;
                this.linkedIds = this.page.list.map(item => item.id)
                this.linkedIds.push(this.workflowId)
            })

            $scope.$on('workflow.updated', () => this.$onChanges())
        }
    })
